import * as THREE from 'three';
import { getBrowserPerformanceProfile } from './Performance.js';

async function initializeWithDeadline(renderer, milliseconds) {
  let timeoutId;
  try {
    await Promise.race([
      renderer.init(),
      new Promise((_, reject) => {
        timeoutId = window.setTimeout(
          () => reject(new Error(`WebGPU initialization exceeded ${milliseconds}ms`)),
          milliseconds
        );
      })
    ]);
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export async function createRenderer(canvas) {
  const performanceProfile = getBrowserPerformanceProfile();
  if (
    navigator.gpu &&
    !navigator.webdriver &&
    !new URLSearchParams(window.location.search).has('webgl')
  ) {
    try {
      const { WebGPURenderer } = await import('three/webgpu');
      const renderer = new WebGPURenderer({
        canvas,
        antialias: performanceProfile.antialias,
        alpha: false
      });
      await initializeWithDeadline(renderer, 2200);
      renderer.userData = renderer.userData ?? {};
      renderer.userData.backend = 'WebGPU';
      renderer.userData.performanceProfile = performanceProfile;
      return renderer;
    } catch (error) {
      console.warn('WebGPU initialization failed; using WebGL.', error);
    }
  }

  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: performanceProfile.antialias,
    powerPreference: 'high-performance'
  });
  renderer.userData = renderer.userData ?? {};
  renderer.userData.backend = 'WebGL 2';
  renderer.userData.performanceProfile = performanceProfile;
  return renderer;
}
